import type { RouteRecordRaw } from 'vue-router'

export const chatRoutes: RouteRecordRaw[] = [
  {
    path: '/chats',
    name: 'chats',
    component: () => import('@/modules/post-mvp/chat/views/ChatsView.vue'),
    meta: {
      title: 'Сообщения',
      requiresAuth: true,
      requiresFeature: 'chat_enabled',
    },
  },
]

export function createChatRoutes() {
  return chatRoutes
}
